export var RegularExpression;
(function (RegularExpression) {
    RegularExpression["ZIP_US"] = "^[0-9]{5}(?:-[0-9]{4})?$";
    RegularExpression["ZIP_US_RESTRICTED"] = "^[0-9]{5}$";
    RegularExpression["ZIP_CA"] = "^[a-zA-Z][0-9][a-zA-Z](-| |)[0-9][a-zA-Z][0-9]$";
    RegularExpression["ZIP_ES"] = "^\\d{5}$";
    RegularExpression["ZIP_FR"] = "^\\d{5}$";
    RegularExpression["ZIP_PR"] = "^[0-9]{5}(?:-[0-9]{4})?$";
    RegularExpression["ZIP_IT"] = "^\\d{5}$";
    RegularExpression["ZIP_DE"] = "^\\d{5}$";
    RegularExpression["ZIP_GB"] = "^[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$";
    RegularExpression["COMPANY_NAME"] = "^[^\\/]+$";
    RegularExpression["PHONE_NUMBER"] = "^[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-/s.]?[0-9]{4}$";
    RegularExpression["FAX"] = "^[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-/s.]?[0-9]{4}$";
    RegularExpression["EPA_NUMBER"] = "^[A-Za-z0-9]+$";
    RegularExpression["TAX_ID"] = "^[A-Za-z0-9]+$";
    RegularExpression["BAR_ID"] = "^[A-Za-z0-9]+$";
    RegularExpression["CURRENCY"] = "^\\-?\\$?\\d*(,\\d\\d\\d)*(\\.[0-9]{2})?$";
    RegularExpression["SPECIAL_CHARACTER"] = "^[a-zA-Z0-9]*$";
    RegularExpression["PHONE_NUMBER_UNFORMATTED"] = "[^0-9 +-]";
    RegularExpression["NUMERIC_ONLY"] = "[^0-9]";
    RegularExpression["FAX_REGEX"] = "^[0-9]+$";
    RegularExpression["MSO_USERNAME_PATTERN"] = "^[a-zA-Z0-9-_\\\\s]*$";
    RegularExpression["WEBSITE_REGEX"] = "^[a-zA-Z0-9][^ ]*[.]+[a-zA-Z0-9][^ ]*$";
    RegularExpression["ODOMETER"] = "^[0-9]*$";
})(RegularExpression || (RegularExpression = {}));
//# sourceMappingURL=RegularExpression.js.map